import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import Reveal from './Reveal';
import AdSlot from './AdSlot';
import { posts, formatPostDate } from '../data/blog';

// Ads appear only where `showAds` is set (the blog page), after every sixth card.
const Blog = ({ limit, category, showAds = false }) => {
  const filtered = category ? posts.filter((post) => post.category === category) : posts;
  const visiblePosts = limit ? filtered.slice(0, limit) : filtered;

  return (
    <div className="blog-grid">
      {visiblePosts.map((post, index) => (
        <React.Fragment key={post.slug}>
          <Reveal as="article" className="blog-card" delay={(index % 3) * 0.06}>
            <Link to={`/blog/${post.slug}`} className="blog-card-link">
              <div className="blog-content">
                <span className="blog-category">{post.category}</span>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <div className="blog-footer">
                  <span className="author">
                    {formatPostDate(post.date)} · {post.readTime}
                  </span>
                  <span className="read-more">
                    Read <FiArrowRight />
                  </span>
                </div>
              </div>
            </Link>
          </Reveal>
          {showAds && (index + 1) % 6 === 0 && index < visiblePosts.length - 1 && (
            <div className="blog-grid-ad">
              <AdSlot key={`${category}-${index}`} type="display" />
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Blog;
